import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ActionSpinner = () => {
  return <FontAwesomeIcon icon={solid("spinner")} pulse spin />;
};
